import * as API from 'common/constant/routes'
import { getJson } from 'helper/http'

export const getDashboardMetrics = () => getJson(API.GET_DASHBOARD_METRICS, {}, {})
